import styled from 'styled-components';

import { black, blue, white } from '../../modules/colors';
import { fonts, spacing } from '../../modules/metrics';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: ${spacing.xl}px 0;
`;

export const Box = styled.div`
  display: flex;
  border-radius: ${spacing.lg}px;
  background-color: ${black};
  color: ${white};
  font-size: ${fonts.md}px;
  padding: ${spacing.lg}px;

  > * a {
    color: ${blue};
  }
`;

export const Title = styled.h1`
  display: inline-flex;
  font-size: ${fonts.lg}px;
  border-radius: ${spacing.lg}px;
  background-color: ${blue};
  color: ${white};
  padding: ${spacing.md}px ${spacing.xl}px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  position: absolute;
  top: -17px;
  z-index: 1;
`;

export const Logo = styled.img`
  width: 100px;
  height: 100%;
`;

export const Content = styled.p`
  line-height: 20px;
  padding: ${spacing.lg}px;
  text-align: center;
`;
